import { useSelector } from "react-redux";
import { ApplicationState } from "store";
import { documentGetRequest, documentOpenGetRequest } from "store/documents/action";
import { changeLayoutMode, changeThemePrimary, setTheme } from "store/layout/action";
import { innitialthemeSettingsJson } from "./InnitialsThemes"
import { useDispatch } from "react-redux";


/**
 * Changes the body attribute
 */
 export const changeHTMLAttribute = (attribute:any, value:any) => {
    if (document.documentElement) document.documentElement.setAttribute(attribute, value);
    return true;
}

export const useCompanyName = () => {
    const user = useSelector((state: ApplicationState) => state.auth.userProfile);
    let companyName = handleCompanyName(user)
    return companyName //theme === '#204ecf' ? user?.tenant?.companyName || 'Zoom abroad' :  "Zilter";
};


export const handleCompanyName = (user: any) => {  
        const hostname = window.location.hostname;
        const theme : any = hostname === 'localhost' && window.location.port ? window.location.port : hostname?.toLowerCase();
        switch(theme){
            case 3000:
            case '3000':
                return 'Zilter'
            case 3001: // Zoom abroad Theme 
            case '3001':
            case 'www.zoomabroad.com':
            case 'app.zoomabroad.com':
                return 'Zoom Abroad'
            case 3002: //extra theme
            case '3002':
                return user?.tenant?.companyName || 'Zilter'
            default:
                return 'Zilter'
        }
    }


export const handleColorChange = (color: any) => {
    const hexToRgb = (hex: string): [number, number, number] => {
                hex = hex?.replace(/^#/, '');
                if (hex?.length === 3) {
                hex = hex?.split('').map(char => char + char).join('');
                }
                const bigint = parseInt(hex, 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;
                return [r, g, b];
            };

            const mixWithWhite = (hex: string, weight: number = 0.8): string => {
                const [r, g, b] = hexToRgb(hex);

                const mix = (channel: number) =>
                Math.round((1 - weight) * channel + weight * 255);

                return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
            };

            const primaryHex = color;
            const primaryRgb = hexToRgb(primaryHex).join(', ');
            const subtleColor = mixWithWhite(primaryHex, 0.8);
            const opacitysubtleColor = mixWithWhite(primaryHex, 0.9);

            document.documentElement.style.setProperty('--primary', primaryHex);
            document.documentElement.style.setProperty('--vz-primary', primaryHex);
            document.documentElement.style.setProperty('--bs-primary', primaryHex);
            document.documentElement.style.setProperty('--vz-primary-rgb', primaryRgb);
            document.documentElement.style.setProperty('--vz-header-border', subtleColor);
            document.documentElement.style.setProperty('--vz-header-bg', primaryHex);
            document.documentElement.style.setProperty('--vz-primary-bg-subtle', subtleColor);
            document.documentElement.style.setProperty('--vz-pagination-active-bg', primaryHex); 
            document.documentElement.style.setProperty('--vz-pagination-active-border-color', primaryHex); 
            document.documentElement.style.setProperty('--vz-link-color', primaryHex); 
            document.documentElement.style.setProperty('--vz-border-color', primaryHex)
            document.documentElement.style.setProperty('--vz-input-border-custom', primaryHex)
            document.documentElement.style.setProperty("--vz-pagination-active-bg", primaryHex);
            document.documentElement.style.setProperty("--vz-pagination-active-border-color", primaryHex);
            document.documentElement.style.setProperty("--vz-primary-text-emphasis", primaryHex)
            document.documentElement.style.setProperty("--vz-vertical-menu-item-active-color", primaryHex)
            document.documentElement.style.setProperty("--vz-vertical-menu-item-active-bg", subtleColor)
            document.documentElement.style.setProperty("--vz-vertical-menu-sub-item-hover-color", primaryHex)
            document.documentElement.style.setProperty("--vz-vertical-menu-sub-item-active-color", primaryHex)
            document.documentElement.style.setProperty("--vz-light-text-emphasis", subtleColor)
            document.documentElement.style.setProperty("--vz-list-group-active-bg", primaryHex)
            document.documentElement.style.setProperty("--vz-list-group-action-hover-bg", opacitysubtleColor)
            document.documentElement.style.setProperty("--vz-topbar-user-bg", opacitysubtleColor)
}

export const fetchLogoUrl = (logo: any, dispatch: any) => {
    if(logo) {
        dispatch(
            documentGetRequest(
                logo,
                "students",
                (error: any) => {
                    console.error("Error fetching avatar:", error);
                },
                (result: { url: string }) => {
                    if (result && result.url) {
                        return result.url
                    }
                }
            )
        );
    }
}

export const handlePort = () => {  
        const hostname = window.location.hostname;
        const theme : any = hostname === 'localhost' && window.location.port ? window.location.port : hostname?.toLowerCase();
        switch(theme){
            case 3000:
            case '3000':
                localStorage.setItem("themeSettings", JSON.stringify(innitialthemeSettingsJson['']));
                return ''
            case 3001: // Zoom abroad Theme 
            case '3001':
            case 'www.zoomabroad.com':
            case 'app.zoomabroad.com':
                localStorage.setItem("themeSettings", JSON.stringify(innitialthemeSettingsJson['#204ecf']));
                return '#204ecf'
            case 3002: //extra theme
            case '3002':
                localStorage.setItem("themeSettings", JSON.stringify(innitialthemeSettingsJson['#a735b3']));
                return '#a735b3'
            default:
                localStorage.setItem("themeSettings", JSON.stringify(''));
                return ''
        }
    }

export const  themeSelector = (dispatch: any, thememode: string) => {
    const theme = handlePort()
    changeHTMLAttribute("data-theme-primary", theme);
    dispatch(changeThemePrimary(theme))
    dispatch(changeLayoutMode(thememode));
    dispatch(setTheme(innitialthemeSettingsJson[theme]))
}

export const logoExtractor = (dispatch: any, logo: any) => {
     dispatch(
        documentOpenGetRequest(
            logo,
            "students",
            (error: any) => {
                console.error("Error fetching avatar:", error);
            },
            (result: { url: string }) => {
                if (result && result.url) {
                    return result.url
                }
            }
        )
    );
}


export const setFavicon = (url?: string) => {
  // If no URL is given, use default favicon from public folder
  const faviconUrl: any = url;

  const link: HTMLLinkElement =
    document.querySelector("link[rel*='icon']") || document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.href = faviconUrl;
  document.head.appendChild(link);
};

export const useDropdownCustomStyle = () => {
    const layoutModeType = useSelector((state: ApplicationState) => state.layout.layoutModeType);
    const themePrimary = useSelector((state: ApplicationState) => state.layout.themePrimary);
    let colorp = themePrimary || '#495057'
    const customStyles = {
        // Customize the style of the dropdown menu
        input: (provided: any) => ({
            ...provided,
            color: layoutModeType === 'light'? 'black' : 'white',
          }),
        control: (provided: any, state: any) => ({
                    ...provided,
                    backgroundColor: 'transparent'
        }),
        menu: (provided: any) => ({
          ...provided,
          backgroundColor: layoutModeType === 'light'? 'white' : `${colorp}`,
          color: layoutModeType === 'light'? 'black' : 'white',
        }),
        // Customize the style of the option in the dropdown menu
        option: (provided: any, state: any) => ({
          ...provided,
          backgroundColor: layoutModeType === 'light'? 'white' : `${colorp}`,
          color: layoutModeType === 'light'? 'black' : 'white',
          '&:hover': {
            backgroundColor: layoutModeType === 'light' ? 'white' : `${colorp}`,
          },
        }),
    }
    return customStyles
}

